class Home {
    constructor() {

        this.slider = document.querySelector('.home-banner-slider');
        if( this.slider ){

            new Swiper(this.slider, {
                autoplay: {
                    delay: 3000
                },
                loop: true,
                speed: 800,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: '.navigation .next-btn',
                    prevEl: '.navigation .prev-btn',
                }
            });

            this.splitTitle();

        }

    }

    splitTitle(){

        const titles = this.slider.querySelectorAll('.title');
        titles.forEach( (title) => {
            const innerSplit = new SplitText(title, {
                type: "lines",
                linesClass: "split-lines"
            });
        });

    }

}